(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-trust-badges"] && !Shopify.designMode) return;
  try {
    const cutoff = new Date();
  cutoff.setHours(14, 0, 0, 0);

  function updateCountdown() {
    const now = new Date();
    let diff = Math.floor((cutoff - now) / 1000);

    if (diff <= 0) {
      document.getElementById('countdown').innerText = '00:00:00';
      return;
    }

    const h = String(Math.floor(diff / 3600)).padStart(2, '0');
    const m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
    const s = String(diff % 60).padStart(2, '0');

    document.getElementById('countdown').innerText = `${h}:${m}:${s}`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
  } catch(e) { console.error(e); }
})();

})();
